function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { SIGNUP_BUTTON_TYPE, SIGNUP_COMBO_BUTTONS_TYPE } from "segments/desktop/core-components/button//button-consts";
import { WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
const getParagraphButtonConfig = ({ buttonSelect, solutionId })=>{
    const { buttonType, signupButtonText, seconderyButtonText } = buttonSelect || {};
    const buttonConfig = {};
    const signupButtonConfig = {
        useCtaText: true,
        ctaText: signupButtonText,
        buttonColor: WORK_OS_IRIS_COLOR_NAME,
        signupWithsolutionAppReferenceId: solutionId
    };
    if (buttonType === SIGNUP_COMBO_BUTTONS_TYPE) {
        buttonConfig.buttonType = buttonType;
        buttonConfig.swapButtonsOrder = true;
        buttonConfig.secondaryButtonConfig = {
            buttonText: seconderyButtonText,
            url: solutionId ? `/templates/template/${solutionId}` : ""
        };
        buttonConfig.signupButtonConfig = signupButtonConfig;
    } else if (buttonType === SIGNUP_BUTTON_TYPE) {
        buttonConfig.buttonType = buttonType;
        Object.assign(buttonConfig, signupButtonConfig);
    }
    return buttonConfig;
};
export const getFullParagraph = ({ title, description, overrideTitle, overrideDescription, topicText, buttonSelect, solutionId, showTitle, showDescription, textAlign, mobileTextAlign })=>{
    return {
        topic: {
            text: topicText,
            color: "brand-blue"
        },
        title: showTitle && (overrideTitle || title || "Template title"),
        body: showDescription && (overrideDescription || description || "Template description"),
        textAlign,
        mobileTextAlign,
        buttonConfig: getParagraphButtonConfig({
            buttonSelect,
            solutionId
        })
    };
};
export const getImageSrcAndAlt = ({ overrideImage, images })=>{
    var _overrideImage_image, _images_, _overrideImage_image1, _images_1;
    return {
        alt: ((_overrideImage_image = overrideImage.image) === null || _overrideImage_image === void 0 ? void 0 : _overrideImage_image.alt) || images && ((_images_ = images[0]) === null || _images_ === void 0 ? void 0 : _images_.title),
        src: ((_overrideImage_image1 = overrideImage.image) === null || _overrideImage_image1 === void 0 ? void 0 : _overrideImage_image1.src) || images && ((_images_1 = images[0]) === null || _images_1 === void 0 ? void 0 : _images_1.url) || "/static/img/segment-layout-default-images/template/template-image-placeholder.png"
    };
};
export const getAsset = ({ overrideImage, images, showImageShadow })=>{
    return _object_spread_props(_object_spread({}, overrideImage), {
        image: _object_spread({}, overrideImage.image || {}, getImageSrcAndAlt({
            images,
            overrideImage
        })),
        shadow: showImageShadow
    });
};
